import { EXTERNAL_EVENTS_SET_HIDDEN_ITEMS } from '@shopify/polaris-viz-core';
import { useState } from 'react';
import { useWatchColorVisionEvents } from '../ColorVisionA11y/useWatchColorVisionEvents.js';

function useExternalHideEvents() {
  const [hiddenIndexes, setHiddenIndexes] = useState([]);
  useWatchColorVisionEvents({
    type: EXTERNAL_EVENTS_SET_HIDDEN_ITEMS,
    onIndexChange: ({
      detail
    }) => {
      setHiddenIndexes(detail.indexes);
    }
  });
  return {
    hiddenIndexes
  };
}

export { useExternalHideEvents };
